import { render, staticRenderFns } from "./bankCardComponent.vue?vue&type=template&id=61831b30"
import script from "./bankCardComponent.vue?vue&type=script&lang=js"
export * from "./bankCardComponent.vue?vue&type=script&lang=js"
import style0 from "./bankCardComponent.vue?vue&type=style&index=0&id=61831b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports